module.exports = __webpack_public_path__ + "public/img/loadApp.3c0d6123.png";